import {
  useMatchCycleResultImportUrl,
  useMatchCycleSupplementsImportUrl,
  useMatchIncidencesUrl,
  useMatchOffcycleResultImportUrl,
  useMatchOffcycleResultsUrl,
  useMatchPaymentUrl,
  useMatchResultUrl,
  useMatchSupplementsUrl,
} from 'modules/payroll_bundle/hooks/useMatchPayrollUrls'
import { usePayrollResults } from 'modules/payroll_bundle/lib/PayrollResultContext'
import { useBulkImportSupplements } from 'modules/payroll_bundle/lib/bulkImportSupplementsContext'
import { LIST_PAYMENTS, UPLOAD_FILE } from 'modules/payroll_bundle/lib/constants'
import { usePayrollPayments } from 'modules/payroll_bundle/lib/payrollPaymentsContext'

const hasResultsNavigation = (payrollResultsStage: string) => {
  return [UPLOAD_FILE, LIST_PAYMENTS].includes(payrollResultsStage)
}

const hasPaymentsNavigation = (payrollPaymentStage: string) => {
  return [LIST_PAYMENTS].includes(payrollPaymentStage)
}

const hasSupplementsNavigation = (bulkImportSupplementStage: string) => {
  return bulkImportSupplementStage === UPLOAD_FILE
}

const useHasNavigation = (policyId?: string | number, periodId?: string | number) => {
  const { payrollResultsStage } = usePayrollResults()
  const { paymentStage } = usePayrollPayments()
  const { bulkImportSupplementStage } = useBulkImportSupplements()

  const isIncidencesPage = useMatchIncidencesUrl()
  const isResultsPage = useMatchResultUrl(policyId, periodId)
  const isOffcycleResultsPage = useMatchOffcycleResultsUrl(String(policyId), String(periodId))
  const isPaymentsPage = useMatchPaymentUrl(policyId, periodId)
  const isSupplementsPage = useMatchSupplementsUrl(String(policyId), String(periodId))
  const isOffcycleResulImportPage = useMatchOffcycleResultImportUrl(
    String(policyId),
    String(periodId)
  )
  const isCycleResulImportPage = useMatchCycleResultImportUrl(String(policyId), String(periodId))
  const isCycleSupplementPage = useMatchCycleSupplementsImportUrl(
    String(policyId),
    String(periodId)
  )

  if (isCycleSupplementPage) return false
  if (isOffcycleResulImportPage || isCycleResulImportPage) return false
  if (isIncidencesPage) return false
  if (isResultsPage || isOffcycleResultsPage) return hasResultsNavigation(payrollResultsStage)
  if (isPaymentsPage) return hasPaymentsNavigation(paymentStage)
  if (isSupplementsPage) return hasSupplementsNavigation(bulkImportSupplementStage)

  return true
}

export default useHasNavigation
